import { useRef } from 'react';
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";

import useNavigateWithTransition from '@/hooks/useNavigateWithTransition';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';
import PlayIconRounded from '@/shared-components/icons/components/actions/PlayIconRounded';
import Text from '@/shared-components/text/components/Text';

import './styles/ArtlistCard.css';

export default function ArtlistCard({ data, style={}, infiniteScrollObserver, fromSearch=false }) {
  const navigateWithTransition = useNavigateWithTransition();
  const imageWrapperRef = useRef(null);

  const title = data.artlist_title || "Artlist";
  const creatorName = data.artlist_creator?.user_username || "User";
  const totalArtworks = data.artlist_artworks ? data.artlist_artworks.length : "a few";
  const altArtlistImage = `Artlist Cover. ${title} by ${creatorName}. ${creatorName} contains ${totalArtworks} artworks.`;

  return (
    <>
      <div 
        className={!fromSearch ? "artlist-card__container" : "artlist-card-from-search__container"}
        style={style} 
        ref={infiniteScrollObserver} 
        onClick={() => {
          imageWrapperRef.current.style.viewTransitionName = `artlist_${data._id}_animation`;
          navigateWithTransition(`/artlist/${data._id}`, { state: { from: true } });
        }}
      >
        <div className="artist-card__artlist-image-wrapper" ref={imageWrapperRef}>
          <ArtlistImage className={!fromSearch ? "artlist-card__artlist-image" : "artlist-card-from-search__artlist-image"} alt={altArtlistImage} image={data.artlist_image?.image_id} />
        </div>

        <div className={"artlist-card__info-container"}>
          {
            !fromSearch ?
              <>
                <div className="artlist-card__info-text">
                  <Text className="artlist-card__artlist-name" paragraph small>
                    {title}
                  </Text>

                  <Text className="artlist-card__artlist-by" paragraph extraSmall>
            by <span>{creatorName}</span>
                  </Text>
                </div>

                <div className="artlist-card__stats-container">
                  <Text className="artlist-card__stats-artworks-count" small>
                    {totalArtworks}
                  </Text>
                  <ArtworkIcon className="artlist-card__stats-artwork-icon"/>
                </div>
              </>
              :
              <>
                <div className="artlist-card__info-text">
                  <Text className="artlist-card__artlist-name" paragraph>
                    {data.artlist_title}
                  </Text>

                  <Text className="artlist-card__artlist-by" paragraph extraSmall>
                    by{" "}
                    <span>
                      {data.artlist_creator.user_username}
                    </span>
                  </Text>
                </div>

                <div className="artlist-card__stats-container">
                  <PlayIconRounded className="artlist-card-from-search__stats-artwork-icon"/>
                </div>
              </>
          }
        </div>
      </div>
    </>
  );
}
